import NEW_PLANS from "configs/newPlans.json";
import { DeploymentData } from "types/deploymentTypes";
import { clusterSizes, freeTrialPeriodDays } from "configs/settings";
import { getSecurityAddOnsMonthlyTotalPrice } from "./Utils";

export const buildOrderSummary = (deploymentData:DeploymentData, securityAddOns:string[], hasUsedFreeTrial:boolean)=>{
    
    const selectedPlan = NEW_PLANS.find((plan) => plan.name.toLowerCase() === deploymentData.deploymentPlan);
    const selectedSize = (clusterSizes.find((size) => size === deploymentData.clusterSize) ?? "small") as keyof NonNullable<typeof selectedPlan>["size"];

    let planTitle = "N/A";
    if(deploymentData.deploymentPlan === "develop") planTitle = "Develop Plan";
    if(deploymentData.deploymentPlan === "scale") planTitle = "Scale Plan";
    if(deploymentData.deploymentPlan === "accelerate") planTitle = "Accelerate Plan";

    let planSize = "N/A";
    if(deploymentData.clusterSize === "small") planSize = "Small";
    if(deploymentData.clusterSize === "medium") planSize = "Medium";
    if(deploymentData.clusterSize === "large") planSize = "Large";



    const planFeatures = selectedPlan?.size[selectedSize].MAU.limit ? `Up to ${selectedPlan?.size[selectedSize].MAU.limit} MAUs` : "N/A";

    let planBadgeText = "N/A";
    if(deploymentData.deploymentPlan === "develop") planBadgeText = "Email / Chat Support";
    if(deploymentData.deploymentPlan === "scale") planBadgeText = "Business-Class Support";
    if(deploymentData.deploymentPlan === "accelerate") planBadgeText = "Dedicated Support";

    let tax = 0;
    let total = 0;
    let yearlyOriginalTotal = 0;

    if (selectedPlan) {
        if (deploymentData.billingCycle === "monthly") {
            total = selectedPlan.size[selectedSize].price.monthly;
        }

        if (deploymentData.billingCycle === "yearly") {
            total = Math.ceil(selectedPlan.size[selectedSize].price.monthly * 12 * 0.8);
        }

        yearlyOriginalTotal = selectedPlan.size[selectedSize].price.monthly * 12
    }

    const monthlySecurityPrice = getSecurityAddOnsMonthlyTotalPrice(securityAddOns);

    let securityPrice = 0;

    let yearlyOriginalSecurityPrice = monthlySecurityPrice * 12;

    if (deploymentData.billingCycle === "monthly") {
        securityPrice = monthlySecurityPrice;
    }

    if (deploymentData.billingCycle === "yearly") {
        securityPrice = Math.ceil(monthlySecurityPrice * 12 * 0.8);
    }

    const subtotal = total + securityPrice;

    const yearlyOriginalSubtotal = yearlyOriginalTotal + yearlyOriginalSecurityPrice;
    
    let totalToday = subtotal + tax;

    let yearlyOriginalTotalToday = yearlyOriginalSubtotal + tax;

    const currentDate = new Date();
    const offsetDays = hasUsedFreeTrial ? 0 : freeTrialPeriodDays;

    // Create a new Date object so we don’t mutate the original
    const dateAfterIncrement = new Date(currentDate);
    dateAfterIncrement.setDate(currentDate.getDate() + offsetDays);

    // Format date for Order Summary UI section
    const formattedDate = dateAfterIncrement.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric"
    });  

    // Format date for Backend n8n Webhook
    const year = dateAfterIncrement.getFullYear();
    const month = String(dateAfterIncrement.getMonth() + 1).padStart(2, "0"); // months are 0-indexed
    const day = String(dateAfterIncrement.getDate()).padStart(2, "0");

    const formattedDateForInvoiceEmail = `${year}-${month}-${day}`;

    return {
        planTitle,
        planFeatures,
        planBadgeText,
        planSize,
        subtotal: subtotal.toFixed(2),
        securityPrice: securityPrice.toFixed(2),
        totalPrice: Number(totalToday.toFixed(2)),
        tax: tax.toFixed(2),
        total: total.toFixed(2),
        totalToday: totalToday.toFixed(2),
        dueDate: formattedDateForInvoiceEmail,
        dueDateFormated: formattedDate,
        yearlyOriginalSecurityPrice: yearlyOriginalSecurityPrice.toFixed(2),
        yearlyOriginalSubtotal: yearlyOriginalSubtotal.toFixed(2),
        yearlyOriginalTotal: yearlyOriginalTotal.toFixed(2),
        yearlyOriginalTotalToday: yearlyOriginalTotalToday.toFixed(2)
    }    

}